module.exports = __webpack_public_path__ + "img/ch6.d91c088c.jpeg";